module.exports = __webpack_public_path__ + "img/image14.de38c6d5.jpeg";